import NextLink from 'next/link';

import Warning from '@/icons/duotone/warning-circle-green.svg';

import type { FunctionComponent } from 'react';
import type { TypeAlertProps } from './types';

export const Alert: FunctionComponent<TypeAlertProps> = ({
  className = '',
  link,
}: TypeAlertProps) => (
  <div
    className={`rounded-custom flex flex-row items-center gap-x-2 border border-secondary-500 bg-secondary-50 py-4 pl-4 pr-2 ${className} `}
  >
    <Warning className="flex-shrink-0" width={32} height={32} />
    <p className="text-body text-body--m font-normal text-primary-900">
      Esta vivienda está ocupada parcialmente los próximos meses{' '}
      <NextLink
        href={link}
        prefetch={false}
        className="text-body text-body--m font-bold text-primary-500"
      >
        Consultar disponibilidad
      </NextLink>
    </p>
  </div>
);

Alert.displayName = 'Alert';
